'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dTransaction$002dDepth$002dExceeded from "./com.raquo.airstream.core.-Airstream-Error$-Transaction-Depth-Exceeded.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024 from "./com.raquo.airstream.core.-Transaction$.js";
import * as $j_com$002eraquo$002eairstream$002eutil$002e$002dJs$002dPriority$002dQueue from "./com.raquo.airstream.util.-Js-Priority-Queue.js";
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dFunction1 from "./scala.-Function1.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction(code) {
  this.ym = null;
  this.rA = null;
  this.yn = 0;
  this.ym = code;
  this.rA = (void 0);
  var x = $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().l7();
  this.yn = ((x === (void 0)) ? 1 : ((1 + x.yn) | 0));
  if ((($j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024.$m_Lcom_raquo_airstream_core_Transaction$().uJ === (-1)) || (this.yn > $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024.$m_Lcom_raquo_airstream_core_Transaction$().uJ))) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dTransaction$002dDepth$002dExceeded.$c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded(this, $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024.$m_Lcom_raquo_airstream_core_Transaction$().uJ));
  } else if ($m_Lcom_raquo_airstream_core_Transaction$onStart$().cG) {
    ($m_Lcom_raquo_airstream_core_Transaction$onStart$().jz.push(this) | 0);
  } else {
    $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().B1(this);
  }
}
export { $c_Lcom_raquo_airstream_core_Transaction as $c_Lcom_raquo_airstream_core_Transaction };
$p = $c_Lcom_raquo_airstream_core_Transaction.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction() {
}
export { $h_Lcom_raquo_airstream_core_Transaction as $h_Lcom_raquo_airstream_core_Transaction };
$h_Lcom_raquo_airstream_core_Transaction.prototype = $p;
$p.SY = (function(observable) {
  var x = this.rA;
  var x$1 = ((x === (void 0)) ? (void 0) : x.ae(observable));
  return ((x$1 === (void 0)) ? false : x$1);
});
$p.TM = (function(observable) {
  var x = this.rA;
  if ((x === (void 0))) {
    var newQueue = new $j_com$002eraquo$002eairstream$002eutil$002e$002dJs$002dPriority$002dQueue.$c_Lcom_raquo_airstream_util_JsPriorityQueue(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable$1) => observable$1.v6)));
    this.rA = newQueue;
    var $x_1 = newQueue;
  } else {
    var $x_1 = x;
  }
  $x_1.TL(observable);
});
var $d_Lcom_raquo_airstream_core_Transaction = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Transaction, "com.raquo.airstream.core.Transaction", ({
  gQ: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction as $d_Lcom_raquo_airstream_core_Transaction };
function $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V($thiz) {
  if ((($thiz.uK.length | 0) === 0)) {
    if ((($thiz.jz.length | 0) > 0)) {
      new $c_Lcom_raquo_airstream_core_Transaction(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
        while ((($thiz.jz.length | 0) > 0)) {
          $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().B1($thiz.jz.shift());
        }
      })));
    }
  } else {
    new $c_Lcom_raquo_airstream_core_Transaction(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
      while ((($thiz.uK.length | 0) > 0)) {
        var callback = $thiz.uK.shift();
        try {
          callback.j(trx);
        } catch (e) {
          var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
          $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(e$2);
        }
      }
      while ((($thiz.jz.length | 0) > 0)) {
        var _trx = $thiz.jz.shift();
        $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().B1(_trx);
      }
    })));
  }
}
export { $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V as $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$onStart$() {
  this.cG = false;
  this.uK = null;
  this.jz = null;
  $n_Lcom_raquo_airstream_core_Transaction$onStart$ = this;
  this.cG = false;
  this.uK = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_scala$002e$002dFunction1.$d_F1.r().C)([])));
  this.jz = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($d_Lcom_raquo_airstream_core_Transaction.r().C)([])));
}
export { $c_Lcom_raquo_airstream_core_Transaction$onStart$ as $c_Lcom_raquo_airstream_core_Transaction$onStart$ };
$p = $c_Lcom_raquo_airstream_core_Transaction$onStart$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction$onStart$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$onStart$() {
}
export { $h_Lcom_raquo_airstream_core_Transaction$onStart$ as $h_Lcom_raquo_airstream_core_Transaction$onStart$ };
$h_Lcom_raquo_airstream_core_Transaction$onStart$.prototype = $p;
var $d_Lcom_raquo_airstream_core_Transaction$onStart$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Transaction$onStart$, "com.raquo.airstream.core.Transaction$onStart$", ({
  gS: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction$onStart$ as $d_Lcom_raquo_airstream_core_Transaction$onStart$ };
var $n_Lcom_raquo_airstream_core_Transaction$onStart$;
function $m_Lcom_raquo_airstream_core_Transaction$onStart$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$onStart$)) {
    $n_Lcom_raquo_airstream_core_Transaction$onStart$ = new $c_Lcom_raquo_airstream_core_Transaction$onStart$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$onStart$;
}
export { $m_Lcom_raquo_airstream_core_Transaction$onStart$ as $m_Lcom_raquo_airstream_core_Transaction$onStart$ };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, transaction) {
  return $thiz.jA.get(transaction);
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V($thiz, transaction) {
  $thiz.uL.unshift(transaction);
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O($thiz) {
  return $thiz.uL.shift();
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V($thiz, parent, newChild) {
  var maybeChildren = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, parent);
  var noChildrenFound = (maybeChildren === (void 0));
  var newChildren = ((maybeChildren === (void 0)) ? $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($d_Lcom_raquo_airstream_core_Transaction.r().C)([]))) : maybeChildren);
  newChildren.push(newChild);
  if (noChildrenFound) {
    $thiz.jA.set(parent, newChildren);
  }
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O($thiz, parent) {
  var maybeParentChildren = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, parent);
  var x = (((maybeParentChildren === (void 0)) || ((maybeParentChildren.length | 0) > 0)) ? maybeParentChildren : (void 0));
  if ((x === (void 0))) {
    return (void 0);
  } else {
    var nextChild = x.shift();
    if (((x.length | 0) === 0)) {
      (!(!$thiz.jA.delete(parent)));
    }
    return nextChild;
  }
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
  this.uL = null;
  this.jA = null;
  $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = this;
  this.uL = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($d_Lcom_raquo_airstream_core_Transaction.r().C)([])));
  this.jA = new Map();
}
export { $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
$p = $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
}
export { $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
$h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype = $p;
$p.B1 = (function(newTransaction) {
  var x = this.l7();
  if ((x === (void 0))) {
    $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V(this, newTransaction);
    $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024.$m_Lcom_raquo_airstream_core_Transaction$().Ob(newTransaction);
    this.TE(newTransaction);
  } else {
    $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V(this, x, newTransaction);
  }
});
$p.TE = (function(transaction) {
  var transaction$tailLocal1 = transaction;
  while (true) {
    var x = this.l7();
    var elem = transaction$tailLocal1;
    if ((!((x !== (void 0)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(elem, x)))) {
      throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Transaction queue error: Completed transaction is not the first in stack. This is a bug in Airstream.");
    }
    this.WI(transaction$tailLocal1);
    transaction$tailLocal1.ym = $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024.$m_Lcom_raquo_airstream_core_Transaction$().DI;
    var maybeNextTransaction = this.l7();
    if ($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(maybeNextTransaction, (void 0))) {
      if (((this.jA.size | 0) > 0)) {
        var numChildren = new $j_java$002elang$002e$002dObject.$c_sr_IntRef(0);
        this.jA.forEach(((numChildren) => ((transactions, _$4) => {
          var ev$12 = ((numChildren.b6 + (transactions.length | 0)) | 0);
          numChildren.b6 = ev$12;
        }))(numChildren));
        throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), (((("Transaction queue error: Stack cleared, but a total of " + numChildren.b6) + " children for ") + (this.jA.size | 0)) + " transactions remain. This is a bug in Airstream."));
      } else {
        return (void 0);
      }
    } else {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction$0024.$m_Lcom_raquo_airstream_core_Transaction$().Ob(maybeNextTransaction);
      transaction$tailLocal1 = maybeNextTransaction;
    }
  }
});
$p.WI = (function(doneTransaction) {
  var doneTransaction$tailLocal1 = doneTransaction;
  while (true) {
    var maybeNextChildTrx = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O(this, doneTransaction$tailLocal1);
    if ($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(maybeNextChildTrx, (void 0))) {
      $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O(this);
      var maybeParentTransaction = this.l7();
      if ((!$j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(maybeParentTransaction, (void 0)))) {
        doneTransaction$tailLocal1 = maybeParentTransaction;
      } else {
        return (void 0);
      }
    } else {
      $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V(this, maybeNextChildTrx);
      return (void 0);
    }
  }
});
$p.l7 = (function() {
  return this.uL[0];
});
var $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$, "com.raquo.airstream.core.Transaction$pendingTransactions$", ({
  gT: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
var $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
function $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$)) {
    $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = new $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
}
export { $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
